import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
    gap: '0.625rem',
    marginBottom: '16px',
    [theme.breakpoints.up(1500)]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
      marginTop: '1rem',
      paddingRight: '0',
    },
    [theme.breakpoints.between(490, 1050)]: {
      gridTemplateColumns: '1fr 1fr',
      marginTop: '1rem',
      paddingRight: '0',
    },
    [theme.breakpoints.between(490, 720)]: {
      gridTemplateColumns: '1fr 1fr',
      flexWrap: 'wrap',
    },
    [theme.breakpoints.between(0, 490)]: {
      gridTemplateColumns: '1fr',
      flexDirection: 'column',
      alignItems: 'initial',
    },
  },
  alertBox: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    padding: '1rem',
    borderRadius: '0.8rem',
    backgroundColor: '#FFF3CD',
    border: '1px solid #FFEAA7',
    boxShadow: '3px 10px 10px 0px rgba(0,0,0,0.03)',
    transition: 'all 0.2s ease-in-out',
    minHeight: '80px',
    gridColumn: 'span 1',
    '&:hover': {
      transform: 'translateY(-1px)',
      boxShadow: '0 4px 8px rgba(0,0,0,0.15)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.875rem',
      minHeight: '70px',
    },
  },
  alertContent: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    flex: 1,
  },
  alertTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#856404',
    margin: 0,
    lineHeight: 1.2,
  },
  alertSubtitle: {
    color: '#353535',
    fontWeight: 500,
    fontSize: '1.125rem',
    margin: 0,
    lineHeight: 1.2,
  },
  iconContainer: {
    width: '45px',
    height: '45px',
    aspectRatio: '1/1',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'rgba(255, 152, 0, 0.1)',
    borderRadius: '0.5rem',
    flexShrink: 0,
  },
  warningIcon: {
    color: '#FF9800',
    fontSize: '20px',
  },
  pendingIcon: {
    color: '#FF9800',
    fontSize: '20px',
  },
}))
